import React from 'react';
import PageBody from '../../components/pagebody/PageBody';
import BasicCard from '../../components/card/basiccard/BasicCard';
import Heading from '../../components/heading/Heading';
import { HEADING } from '../../components/heading/constants/constants';
import styles from './SupportSection.style'

export default function SupportSection() {

    const supportLinks = [
		{ label: 'Knowledge Base (Classic)', link: 'https://zenwork.force.com/SupportTax1099/s/' },
		{ label: 'Knowledge Base (New UI)', link: 'https://zenwork.my.site.com/SupportTax1099/s/topic/0TO3u000000UnIKGA0/new-user-interface-ui' },
		{ label: 'Training Sessions', link: 'https://www.tax1099.com/1099-efile-resources' },
		{ label: 'How-To-Videos', link: 'https://www.tax1099.com/1099-efile-resources#Vd' },
		{ label: 'State Filing Info', link: 'https://www.tax1099.com/1099-state-filing-requirements' },
		{ label: 'Pricing', link: 'https://www.tax1099.com/tax-1099-efile-pricing' },
	]


    return (
        <PageBody>
            <Heading type={HEADING.H1}>Help & Support</Heading>
            <div style={styles.mainContainer}>
                {supportLinks.map(link => <div onClick={()=>{window.open(link.link, 'mywindow', 'noopener')}}>
                    <BasicCard circularCheckboxStyles={styles.displayNone} customStyles={styles.pointerCursor} isHighlighted={true} >{link.label}</BasicCard>
                    </div>
                    )}
            </div>
        </PageBody>
    )
}